import request from '@/utils/request'

const baseUrl = '/erp/delivery/wave-pick'

export const pageDeliveryWavePick = params => request({ url: baseUrl + '/page', method: 'get', params })
export const getDeliveryWavePick = id => request({ url: baseUrl + '/detail', method: 'get', params: { id } })
export const listWavePickOutboundSources = params => request({ url: baseUrl + '/outbound-sources', method: 'get', params })
export const listWavePickOutboundLines = (outboundId, excludeWaveId) => request({
  url: baseUrl + '/outbound-lines',
  method: 'get',
  params: { outboundId, excludeWaveId: excludeWaveId || undefined }
})
export const createDeliveryWavePick = data => request({ url: baseUrl + '/add', method: 'post', data })
export const updateDeliveryWavePick = data => request({ url: baseUrl + '/edit', method: 'post', data })
export const startWavePick = id => request({ url: baseUrl + '/start-pick', method: 'post', data: { id } })
export const completeWavePickReview = id => request({ url: baseUrl + '/complete-review', method: 'post', data: { id } })
export const deleteDeliveryWavePick = id => request({ url: baseUrl + '/delete', method: 'post', data: { id } })
export const exportDeliveryWavePick = ids => request({
  url: baseUrl + '/export',
  method: 'post',
  data: { ids },
  responseType: 'blob'
})
